<template>
  <div class="row">
    <div class="panel text-danger">
      <div class="panel-body">
        該当のURLは存在しません。
      </div>
    </div>
  </div>

</template>

<script>
  import TagAppend from '@/components/TagAppend.vue'
  import TagListRow from '@/components/tag/ListRow.vue'

  export default {
    created: function () {
      this.show = true
      if (!this.language) {
        this.language = 'jp'
      }

      this.init()
    },
    data () {
      return {
        show: false,
        site: {
          title: ''
        },
        tags: [
          {name: '株式会社クイック', check: false},
          {name: '株式会社クイック', check: false},
          {name: '株式会社クイック', check: false},
          {name: '株式会社クイック', check: false},
          {name: '株式会社クイック', check: false},
          {name: '株式会社クイック', check: false},
          {name: '株式会社クイック', check: false}
        ]
      }
    },
    methods: {
      init: function () {
      },
      post: function () {
        var me = this
        for (var i = 0; i < this.tags.length; i++) {
          me.tags[i].check = true
        }
      }
    },
    components: {
      TagAppend,
      TagListRow
    }
  }
</script>




// WEBPACK FOOTER //
// NotFound.vue?b562f302